import { AuthContext } from "../../../../../../contexts/AuthContext";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useMemo, useState } from "react";
import { MyAreaTitle } from "../../components";
import RequestedFeedback from "./components/RequestedFeedback";
import { useGetFeedback360Result } from "./hooks";
import PersonalFeedback from "./components/PersonalFeedback";

export interface AssessmentStatus {
  personalityFileAvailable: boolean;
  careerFileAvailable: boolean;
}

export function Feedback360() {
  const { t } = useTranslation("myArea");
  const { user, configurations } = useContext(AuthContext);
  const { i18n } = useTranslation();

  const { data: FeedbackResult, isLoading: isLoadingExisting } =
    useGetFeedback360Result();
  const [activeTab, setActiveTab] = useState<string>(
    FeedbackResult ? "your-personal-feedback" : "request-feeback"
  );

  const tabs = useMemo(() => {
    const baseTabs = [
      FeedbackResult ? "your-feedback-requests" : "request-feeback",
    ];

    if (FeedbackResult) {
      baseTabs.unshift("your-personal-feedback");
    }

    return baseTabs;
  }, [FeedbackResult]);

  useEffect(() => {
    if (FeedbackResult) {
      setActiveTab("your-personal-feedback");
    } else {
      setActiveTab("request-feeback");
    }
  }, [FeedbackResult]);

  if (isLoadingExisting) {
    return (
      <div className="w-full text-center py-8">
        {t("assessments.feedback360.loading")}
      </div>
    );
  }

  return (
    <div>
      <div className="hidden lg:flex">
        <MyAreaTitle title={t("assessments.title-feedback360")} />
      </div>
      <div className="mb-6 ">
        <span>{t(`assessments.feedback360.explanatory-text`)}</span>
      </div>

      <>
        <div className="flex w-full">
          {tabs.map((tab) => (
            <div
              key={tab}
              className={`pt-2 pb-0 pl-0 pr-4 cursor-pointer ${
                activeTab === tab ? "font-bold" : ""
              }`}
              onClick={() => setActiveTab(tab)}
            >
              <span className="p-2 pb-0 mb-2 flex">
                {t(`assessments.feedback360.${tab}`)}
              </span>
              {activeTab === tab && (
                <div className="h-[2px] bg-Yellow-default w-full" />
              )}
            </div>
          ))}
        </div>
        <hr />

        {activeTab === "your-personal-feedback" && (
          <>
            <PersonalFeedback />
          </>
        )}
        {(activeTab === "your-feedback-requests" ||
          activeTab === "request-feeback") && (
          <>
            <RequestedFeedback />
          </>
        )}
      </>
    </div>
  );
}
